<template>
  <div id="s1_Easy" class="sidebar">
    <div id="l1_Easy_conversation_list" :class="{ 'popular': showPopular}">
      <h5><span>{{ $t('sidebar.channel') }}</span> <i class="pi pi-plus-circle cursor-pointer" @click="toggleChannelMenu"></i></h5>
      <ul id="ul_EasyForChannels">
        <li v-for="(conversation) in filteredChannels" :key="conversation.id"
          :class="{ 'selected_tab': (selected_id == conversation.id), 'unread_channel': conversation.unread }"
          @click="selectConversation(conversation.id)">
          <span class="chan_smile">{{ conversation.smile }}</span> #{{ conversation.name }} 
          <i class="conversation_action_icon pi pi-ellipsis-v" v-if="my_profile.access > 50 || conversation.user_access > 4"
            @click.stop="openChannelMenu($event,conversation.id)"></i>
          <i class="conversation_action_icon pi pi-times" v-else  @click="closeChannel(conversation.id)"></i>
        </li>
      </ul>
      <h5><span>{{ $t('sidebar.priv') }}</span></h5>
      <ul id="ul_EasyForPrivs">
        <li v-for="(conversation) in filteredConversations" :key="conversation.id"
          :class="{ 'selected_tab': (selected_id == conversation.id) }" @click="selectConversation(conversation.id)">
          <Avatar :label="conversation.name.charAt(0).toUpperCase()" size=""
            style="background-color:#2196F3; color: #ffffff; cursor: pointer;" shape="circle" 
            v-if="!conversation.avatar" />
          <Avatar :image="$utils.getAvatar(conversation.avatar)" size=""
            style="background-color:#2196F3; color: #ffffff; cursor: pointer;" shape="circle" v-else  />

          {{ conversation.name }}

          <Badge :value="conversation.unread" severity="danger" v-if="conversation.unread > 0" size="small"
            class="ml-auto mr-4" />
          <i class="conversation_action_icon pi pi-times" @click.stop="closeConversation($event, conversation.id)"></i>
          <span class="conversation_user_online_badge" v-if="conversation.online"></span>

        </li>
      </ul>


      <div v-if="filteredConversations.length == 0" id="no_conversations">
        <span class="material-symbols-outlined mt-2 mb-2" id="no_conversation_icon" translate="no">
          chat_bubble
        </span>
        <p v-html="$t('sidebar.no_conversations')"></p>
      </div>

      <div id="l1_Easy_popular" v-if="!chatTokenForSystem">
        <h5 class="mb-3"><span>{{ $t('sidebar.popular_users') }}</span> <i @click="showPopular = !showPopular"
            class="pi " :class="{ 'pi-chevron-down': showPopular, 'pi-chevron-up': !showPopular }"></i></h5>
        <div id="EasyForPopular" v-if="showPopular">
          <span class="popular_user-border popular_add_me"  v-if="my_profile.avatar">
            <img @click="addMeToFavorite()" :src="$utils.getAvatar(my_profile.avatar)" v-tooltip="my_profile.nickname"
              class="popular_avatar">
            <span id="add_me" @click="addMeToFavorite()" class="cursor-pointer">{{ $t('sidebar.add_me') }}</span>
          </span>

          <span class="popular_user-border" v-for="user in popular_users" :key="user.user_id">
            <img @click="selectUser(user)" :src="$utils.getAvatar(user.avatar)" v-tooltip="user.nickname"
              class="popular_avatar">
          </span>
        </div>
      </div>


      <Menu :model="PmMenuItems" :popup="true" ref="privateMessageMenu" />
      <Menu :model="channelMenuItems" :popup="true" ref="channelMenu" />
      <Menu :model="channelMenuItemsForAdmin" :popup="true" ref="channelMenuAdmin" />

    </div>


  </div>




</template>

<script>
import { ref } from 'vue';



export default {
  props: ['conversations', 'selected', 'my_profile', 'selected_id', 'popular_users', 'create_channel', 'chatTokenForSystem'],
  components: {

  },

  setup() {
    const avatarMenu = ref(null);
    const channelMenu = ref(null);
    const privateMessageMenu = ref(null);

    const toggleAvatarMenu = (event) => {
      if (avatarMenu.value) {
        avatarMenu.value.toggle(event);
      }
    };

    const toggleChannelMenu = (event) => {
      if (channelMenu.value) {
        channelMenu.value.toggle(event);
      }
    };


    const tooglePrivateMessageMenu = (event) => {
      if (privateMessageMenu.value) {
        privateMessageMenu.value.toggle(event);
      }
    };

    return { avatarMenu, toggleAvatarMenu, channelMenu, toggleChannelMenu, privateMessageMenu, tooglePrivateMessageMenu };
  },
  data() {
    return {
      closedPrivateMessages: null,
      showPopular: true,
      selectedChannelId: null,
      channelMenuItemsForAdmin: [
      {
          label: this.$t('sidebar.manage_channel'),
          icon: 'pi pi-fw pi-cog',
          command: () => {
            this.manageChannel(this.selectedChannelId);
          }
        },
        {
          label: this.$t('sidebar.part_channel'),
          icon: 'pi pi-fw pi-times',
          command: () => {
            this.closeChannel(this.selectedChannelId);
          }
        },
      ],
      PmMenuItems: [
        {
          label: this.$t('sidebar.close_window'),
          icon: 'pi pi-fw pi-times',
          command: () => {
            this.$emit('send-events', { action: 'close-private', id: this.closedPrivateMessages });
          }
        },
        {
          label: this.$t('sidebar.delete_private_conversation'),
          icon: 'pi pi-fw pi-trash',
          command: () => {
            this.$emit('send-events', { action: 'remove-private', id: this.closedPrivateMessages });
          }
        }
      ],

      channelMenuItems: [
        {
          label: this.$t('sidebar.channel_list'),
          icon: 'pi pi-fw pi-list',
          command: () => {
           this.$socket.emit('channelList');
          }
        },
        {
          label: this.$t('sidebar.create_channel'),
          icon: 'pi pi-fw pi-plus',
          command: () => {
            if (this.create_channel == -1) {
              this.$emit('send-events', { action: 'create-channel-disabled' });
            } else {
              this.$emit('send-events', { action: 'create-channel-dialog' });

            }
          }
        }
      ],


    };
  },
  methods: {
    selectConversation(id) {
      this.$emit('update-selected', id); // 'selected' prop'unu güncellemek için bir olay gönderir
    },
    addMeToFavorite() {
      this.$emit('send-events', { action: 'add-to-favorite' });
    },
    closeConversation(event, id) {
      this.closedPrivateMessages = id;
      this.tooglePrivateMessageMenu(event);
    },
    manageChannel(channel_id) {
      this.$socket.emit('manageChannel', channel_id);
    },

    openChannelMenu  (event, id)  {
      console.log(event);
      this.selectedChannelId = id;
      this.$refs.channelMenuAdmin.toggle(event);
    },

    closeChannel(id) {
      this.$emit('send-events', { action: 'close-channel', id: id });
    },

    selectUser(user) {
      this.$emit('send-events', { action: 'open-user-profile', user: user }); // 'selected' prop'unu güncellemek için bir olay gönderir
    },
  },
  computed: {
    filteredConversations() {
      return this.conversations.filter(conversation => conversation.private);
    },
    filteredChannels() {
      return this.conversations.filter(conversation => (!conversation.private && conversation.id != 0 ));
    }
  }
};
</script>


<style scoped>
#s1_Easy {
  border-right: 1px solid var(--p-neutral-300);
  background: var(--p-neutral-50);
  width: 320px;
  float: left;
  height: 100%;
  position: relative;
}

#s1_Easy ul {
  list-style-type: none;
  padding: 0 10px;
  margin: 0;
}

#no_conversations {
  padding: 10px;
  font-size: 14px;
  text-align: center;
  color: var(--p-neutral-500);
}

#no_conversation_icon {
  font-size: 60px;
  background-image: var(--gradient--background-brand-gradient);
  background-clip: text; /* Add this line for standard compatibility */
  -webkit-background-clip: text; /* Keep this line for WebKit-based browsers */
  -webkit-text-fill-color: transparent;
}

#ul_EasyForChannels li {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
  margin-bottom: 1px;
  padding-left: 25px;
  position: relative;
  border-radius: 5px;
}

#ul_EasyForPrivs li {
  position: relative;
  padding: 0.5rem;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chan_smile {
  position: absolute;
  left: 0;
  top: 5px;
}

#ul_EasyForChannels li:hover,
#ul_EasyForPrivs li:hover {
  background-color: var(--p-neutral-300);
}

#ul_EasyForChannels li.selected_tab,
#ul_EasyForPrivs li.selected_tab {
  background-color: var(--p-neutral-200);
}

#ul_EasyForChannels .conversation_action_icon {
  display: none;
  position: absolute;
  right: 5px;
  top: 8px;
}

#ul_EasyForPrivs .conversation_action_icon {
  display: none;
  position: absolute;
  right: 5px;
  top: 14px;
}

#ul_EasyForChannels li:hover .conversation_action_icon,
#ul_EasyForPrivs li:hover .conversation_action_icon {
  display: block;
}

div#l1_Easy_conversation_list h5 {
  font-size: 14px;
  line-height: 16px;
  margin: 0;
  padding-top: 16px;
  padding-left: 11px;
  color: var(--p-neutral-600);
  display: flex;
  margin-bottom: 4px;
  position: relative;
}

div#l1_Easy_conversation_list h5 i {
  margin-left: auto;
  margin-right: 12px
}

div#l1_Easy_conversation_list {
  height: calc(100% - 60px);
  overflow: auto;
}

div#l1_Easy_conversation_list.popular {
  height: calc(100% - 297px);
}

.p-avatar.p-component.p-avatar-image.popular_avatar img {
  height: 46px;
  width: 46px;
  object-fit: cover;
}

div#EasyForPopular {
  display: flex;
  width: 100%;
  overflow: hidden;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

div#EasyForPopular div {
  float: left;
  padding: 8px;
  display: block;
  width: 52px;
  height: 52px;
}

img.popular_avatar {
  height: 47px;
  width: 47px;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.752);
  cursor: pointer;
}

.popular_user-border {
  background: linear-gradient(225deg, #fc17bf 14.64%, #fc17fc 37.98%, #fcc217 85.36%);
  height: 50px;
  width: 50px;
  border-radius: 12px;
  position: relative;
}

.popular_user-border.popular_add_me {
  background: linear-gradient(225deg, orange 14.64%, orange 37.98%, orange 85.36%);
}

span#add_me {
  position: absolute;
  font-size: 11px;
  width: 100%;
  background: orange;
  border-radius: 5px;
  bottom: 0;
  text-align: center;
}

.popular_user-border::before {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  height: 50px;
  width: 50px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.2)
}

.popular_user-border img {
  position: absolute;
  top: 1.7px;
  left: 1.5px;

}

@media screen and (max-width: 768px) {

  #s1_Easy {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100vw;
    height: calc(100vh - 100px);
    z-index: 1000;
    left: -100%;
  }

}

div#l1_Easy_popular {
  position: absolute;
  bottom: 0;
  width: 100%;
}

#l1_Easy_popular i {
  cursor: pointer;
}

.conversation_user_online_badge {
  position: absolute;
  left: 30px;
  top: 27px;
  width: 8px;
  height: 8px;
  background-color: green;
  border-radius: 50%;
  display: block;
}
</style>